import styled from 'styled-components';
export const CanvasInnerDefault = styled.div `
  position: relative;
  outline: 1px dashed rgba(0,0,0,0.1);
  width: 10000px;
  height: 10000px;
  cursor: move;
`;
